import { z } from 'zod';

export const LocaleSchema = z.enum(['en', 'zh']);

export type Locale = z.infer<typeof LocaleSchema>;

export type Language = {
  code: Locale;
  name: string;
};

/** Route params for pages under app/[lang] (Next 16 passes them as a Promise). */
export type ParamsWithLng = Promise<{ lang: string }>;

/** Narrow a route segment to a supported locale, falling back to English. */
export const resolveLocale = (lang: string | undefined): Locale => {
  const parsed = LocaleSchema.safeParse(lang);
  return parsed.success ? parsed.data : 'en';
};
